import { render, staticRenderFns } from "./WorkspaceFoldersDimensions.vue?vue&type=template&id=04102fc8&"
import script from "./WorkspaceFoldersDimensions.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFoldersDimensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports